import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IStage } from 'interface/stageInterface';

interface StagesState {
  stages: IStage[];
}

const initialState: StagesState = {
  stages: [],
};

const stagesSlice = createSlice({
  name: 'stages',
  initialState,
  reducers: {
    setStages: (state, action: PayloadAction<IStage[]>) => {
      state.stages = action.payload;
    },
  },
});

export const { setStages } = stagesSlice.actions;
export default stagesSlice.reducer;
